import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import { parseTimeInMillis } from '../../../../utils/time';
import useComponentMounted from '../../../../hooks/useComponentMounted';
import {
  StyledTimeCounter,
} from './styles';

const TimeCounter = ({
  run,
  className,
  currentTimeUpdated,
}) => {
  const [currentTime, setCurrentTime] = useState(0);
  const [timerId, setTimerId] = useState(null);

  const isComponentMountedRef = useComponentMounted();

  useEffect(() => {
    const updateTime = () => {
      // Get a time snapshot at the beginning to later compare it and calculate the precise elapsed time.
      const initialTime = performance.now();

      const id = setTimeout(() => {
        const timeoutTime = performance.now();

        // Compute how many millisecods have actually passed
        const elapsedime = timeoutTime - initialTime;

        if (isComponentMountedRef.current) {
          setCurrentTime(currentTime + elapsedime);
          setTimerId(null);
        }
      }, 250);

      // Save the timer id in case we need to clear this timeout
      setTimerId(id);
    };

    if (run && !timerId) {
      updateTime();
    }
  }, [
    run,
    currentTime,
    setTimerId,
    timerId,
    isComponentMountedRef,
  ]);

  useEffect(() => {
    if (currentTimeUpdated) {
      currentTimeUpdated(currentTime);
    }
  }, [
    currentTime,
    currentTimeUpdated,
  ]);

  return (
    <StyledTimeCounter className={className}>
      {parseTimeInMillis(currentTime)}
    </StyledTimeCounter>
  );
};

TimeCounter.propTypes = {
  run: PropTypes.bool.isRequired,
  className: PropTypes.string,
  currentTimeUpdated: PropTypes.func,
};

TimeCounter.defaultProps = {
  className: '',
  currentTimeUpdated: null,
};

export default TimeCounter;
